import GalleryCommunityUser from 'components/Community/GalleryCommunityUser/GalleryCommunityUser';
import { withGalleryCommunityUserProps } from 'viewModel/gallery/withGalleryCommunityUserProps';

export default withGalleryCommunityUserProps(GalleryCommunityUser);
